import { useState } from "react";
import { useDebounce } from "../../../../../hooks/use-debounce";
import ElevatedPaper from "../../../../ElevatedPaper";
import {
  DEFAULT_EDUCATION_MATERIAL_FILTER_VALUES,
  EducationMaterialFilterInitialValuesType,
} from "./EducationMaterialFilter";
import EducationMaterialTable from "./EducationMaterialTable";
import EducationMaterialTopBar from "./EducationMaterialTopBar";

const EducationLayout = () => {
  const [filter, setFilter] =
    useState<EducationMaterialFilterInitialValuesType>(
      DEFAULT_EDUCATION_MATERIAL_FILTER_VALUES
    );
  const [search, setSearch, instantSearchVal] = useDebounce("");
  const [archive, setArchive] = useState<boolean>(false);

  return (
    <ElevatedPaper>
      <EducationMaterialTopBar
        onApply={setFilter}
        filters={filter}
        instantSearchVal={instantSearchVal}
        setSearch={setSearch}
        archive={archive}
        setArchive={setArchive}
        setFilter={setFilter}
      />

      <EducationMaterialTable
        filter={filter}
        search={search}
        archive={archive}
        setFilter={setFilter}
      />
    </ElevatedPaper>
  );
};

export default EducationLayout;
